import { render, staticRenderFns } from "./ServicepointsTable.vue?vue&type=template&id=c2f7d382&scoped=true"
import script from "./ServicepointsTable.vue?vue&type=script&lang=ts"
export * from "./ServicepointsTable.vue?vue&type=script&lang=ts"
import style0 from "./ServicepointsTable.vue?vue&type=style&index=0&id=c2f7d382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f7d382",
  null
  
)

export default component.exports